import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { SearchTableFilterComponent } from '@clean-code/shared/components/ui-data-table';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslocoModule } from '@jsverse/transloco';
import { TimeSeriesAnalysisIdentifierSearchComponent } from './time-series-analysis-identifier-search.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,

    TranslocoModule,

    MatInputModule,

    MatButtonModule,
    FontAwesomeModule,
    SearchTableFilterComponent,
  ],
  declarations: [TimeSeriesAnalysisIdentifierSearchComponent],
  exports: [TimeSeriesAnalysisIdentifierSearchComponent],
})
export class TimeSeriesAnalysisIdentifierSearchModule {}
